import Stack from 'atoms/Layout/Stack/Stack';
import styled from 'styled-components';

export const InputContainer = styled(Stack)`
  .search-button {
    padding: 0;
  }
`;
